import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-best-practice',
  templateUrl: './best-practice.component.html',
  styleUrls: ['./best-practice.component.css']
})
export class BestPracticeComponent implements OnInit {
  banner: any = {
    pagetitle: "Best Practices",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Best Practices",
  }

  constructor() { }

  ngOnInit(): void {
  }

}
